import { msg } from "../../../../locales/translate";
export const client_registration_form_step_6 = {
	model: {
		company: {
			certificate_of_incorporation: "",
			memorandum_and_articles_of_association: "",
			extract_from_company_register: "",
			proof_of_registered_address: "",
			bank_statement_or_account_confirmation: "",
		},

		additional_documents: {
			payment_agent_agreement: "",
			proof_of_business_address: "",
			operating_licence: "",
			aml_ctf_policy: "",
			mrlo_cv: "",
			power_of_attorney: "",
			declaration_of_trust: "",
			processing_statement: "",
			pci_dss_certificate: "",
		},

		// beneficial_owners: {
		// 	government_id: "",
		// 	proof_of_address: "",
		// },

		// directors: {
		// 	government_id: "",
		// 	proof_of_address: "",
		// },

		corporate_shareholders: {
			certificate_of_incorporation: "",
			extract_from_company_register: "",
			ownership_structure: "",
			directors_and_beneficial_owners_ids: "",
		},
	},
};

export const client_registration_form_step_6_decorator = {
	model: {
		company: {
			get $__certificate_of_incorporation_label() { return msg("certificateOfIncorporation"); },
			get $__certificate_of_incorporation_subtitle() { return msg("confirmsCompanyRegistration"); },
			$__certificate_of_incorporation_type: "file",

			get $__memorandum_and_articles_of_association_label() { return msg("memorandumAndArticlesOfAssociation"); },
			get $__memorandum_and_articles_of_association_subtitle() { return msg("confirmsCompanyStructureAndGovernance"); },
			$__memorandum_and_articles_of_association_type: "file",

			get $__extract_from_company_register_label() { return msg("extractFromCompanyRegisterRecent3MonthsOrEquivalent"); },
			get $__extract_from_company_register_subtitle() { return msg("confirmsDirectorsShareholdersAndRegisteredAddress"); },
			$__extract_from_company_register_type: "file",

			get $__proof_of_registered_address_label() { return msg("proofOfRegisteredAddressOnlyIfNotVisibleInRegisterExtract"); },
			get $__proof_of_registered_address_subtitle() { return msg("eGCertificateOfIncumbencyOrCertificateOfRegisteredOffice"); },
			$__proof_of_registered_address_type: "file",

			get $__bank_statement_or_account_confirmation_label() { return msg("bankStatementOrAccountConfirmation"); },
			get $__bank_statement_or_account_confirmation_subtitle() { return msg("showsAccountHolderNameAndIbanForPayoutAccount"); },
			$__bank_statement_or_account_confirmation_type: "file",
		},
		$__company_decorator: {
			get title() { return msg("aCompanyDocuments"); },
			blockless: true,
		},

		additional_documents: {
			get $__payment_agent_agreement_label() { return msg("paymentAgentAgreementIfApplicable"); },
			get $__payment_agent_agreement_subtitle() { return msg("requiredOnlyIfPayoutsGoToAPaymentAgentSAccount"); },
			$__payment_agent_agreement_type: "file",

			get $__proof_of_business_address_label() { return msg("proofOfActualBusinessAddressIfDifferentFromRegistered"); },
			get $__proof_of_business_address_subtitle() { return msg("ifApplicableRequiredOnlyIfTheCompanyOperatesFromAnotherLocation"); },
			$__proof_of_business_address_type: "file",

			// $__operating_licence_label: "Relevant operating licence",
			// $__operating_licence_subtitle:
			// 	"e.g. gambling, investment, or financial licence (if gambling license) should consist of a list of approved websites by the regulator.",
			// $__operating_licence_type: "file",

			// $__aml_ctf_policy_label: "AML/CTF Policy",
			// $__aml_ctf_policy_subtitle:
			// 	"Should contain: KYC/KYB, CDD/EDD measures, sanctions screening, list of high/prohibited countries, ongoing monitoring measures.",
			// $__aml_ctf_policy_type: "file",

			// $__mrlo_cv_label: "MLRO CV",
			// $__mrlo_cv_subtitle: "Confirms AML officer’s experience and appointment",
			// $__mrlo_cv_type: "file",

			// $__power_of_attorney_label: "Power of Attorney",
			// $__power_of_attorney_subtitle:
			// 	"Confirms authorisation of the signatory / representative*\n\n*Not required if the authorised representative is Director of the company.",
			// $__power_of_attorney_type: "file",

			get $__declaration_of_trust_label() { return msg("declarationOfTrust"); },
			get $__declaration_of_trust_subtitle() { return msg("ifNomineeIdentifiedIfBeneficialOwnershipIsHeldInTrust"); },
			$__declaration_of_trust_type: "file",

			// $__processing_statement_label: "Processing statement (last 6 months)",
			// $__processing_statement_subtitle: "Required if the client has selected the Card Processing service",
			// $__processing_statement_type: "file",

			// $__pci_dss_certificate_label: "PCI DSS Certificate",
			// $__pci_dss_certificate_subtitle: "(applicable for card processing services only) Required if the client stores or processes card data",
			// $__pci_dss_certificate_type: "file",
		},

		$__additional_documents_decorator: {
			get title() { return msg("bAdditionalDocuments"); },
			blockless: true,
		},

		// beneficial_owners: {
		// 	$__government_id_label: "Government-issued photo ID (Passport / National ID)",
		// 	$__government_id_subtitle: "Must show full name, date of birth, and expiry date",
		// 	$__government_id_type: "file",

		// 	$__proof_of_address_label: "Proof of address (utility bill, bank statement, or other official document ≤3 months old)",
		// 	$__proof_of_address_subtitle: "Must show name and residential address",
		// 	$__proof_of_address_type: "file",
		// },

		// $__beneficial_owners_decorator: {
		// 	title: "C. Beneficial Owners (UBOs)",
		// 	blockless: true,
		// },

		// directors: {
		// 	$__government_id_label: "Government-issued photo ID (Passport / National ID)",
		// 	$__government_id_subtitle: "For at least two directors",
		// 	$__government_id_type: "file",

		// 	$__proof_of_address_label: "Proof of address (utility bill, bank statement, or other official document ≤3 months old)",
		// 	$__proof_of_address_subtitle: "For the same directors",
		// 	$__proof_of_address_type: "file",
		// },

		// $__directors_decorator: {
		// 	title: "D. Directors",
		// 	subtitle: "Please upload identification documents for at least two directors.",
		// 	blockless: true,
		// },

		corporate_shareholders: {
			get $__certificate_of_incorporation_label() { return msg("certificateOfIncorporationOfTheLegalEntity"); },
			get $__certificate_of_incorporation_subtitle() { return msg("confirmsCompanyRegistration"); },
			$__certificate_of_incorporation_type: "file",

			get $__extract_from_company_register_label() { return msg("extractFromCompanyRegisterRecent3Months"); },
			get $__extract_from_company_register_subtitle() { return msg("confirmsOwnershipManagementAndRegisteredAddress"); },
			$__extract_from_company_register_type: "file",

			get $__ownership_structure_label() { return msg("proofOfOwnershipChainToUltimateBeneficialOwners"); },
			get $__ownership_structure_subtitle() { return msg("showsFullControlStructure"); },
			$__ownership_structure_type: "file",

			get $__directors_and_beneficial_owners_ids_label() { return msg("idDocumentAndProofOfAddressForDirectorsBeneficialOwnersOfThe_d32d43fd"); },
			get $__directors_and_beneficial_owners_ids_subtitle() { return msg("requiredForTransparencyAndTraceability"); },
			$__directors_and_beneficial_owners_ids_type: "file",
		},
		$__corporate_shareholders_decorator: {
			get title() { return msg("cCorporateShareholdersDirectorsIfApplicable"); },
			get subtitle() { return msg("ifAnyShareholderOrDirectorIsALegalEntityPleaseUploadTheFollo_88d9f28b"); },
			blockless: true,
		},
	},

	$__model_decorator: {
		blockless: true,
		sx: { gap: "30px" },
	},
};
